import { render, staticRenderFns } from "./WidgetHeaderButtons.vue?vue&type=template&id=5b4e2b67&scoped=true&"
import script from "./WidgetHeaderButtons.vue?vue&type=script&lang=js&"
export * from "./WidgetHeaderButtons.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHeaderButtons.vue?vue&type=style&index=0&id=5b4e2b67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e2b67",
  null
  
)

export default component.exports